import React from 'react';
import { Menu } from 'lucide-react';
import SourcityLogo from '../../imports/SourcityLogoWordmarkIconEmbedded1';
import { LanguageToggle } from './language-toggle';

interface MobileHeaderProps {
  onMenuClick: () => void;
}

export function MobileHeader({ onMenuClick }: MobileHeaderProps) {
  return (
    <div className="fixed top-0 start-0 end-0 z-30 md:hidden">
      <div className="bg-white/70 backdrop-blur-2xl border-b border-white/40 shadow-sm">
        <div className="flex items-center justify-between px-4 py-3">
          {/* Sourcity Logo */}
          <div className="w-32 h-8">
            <SourcityLogo />
          </div>
          
          <div className="flex items-center gap-2">
            <LanguageToggle variant="compact" />

            {/* Menu Button */}
            <button
              onClick={onMenuClick}
              className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/60 hover:bg-white/80 active:scale-95 transition-all border border-white/40"
            >
              <Menu className="h-5 w-5 text-[#434343]" />
            </button>
          </div>
        </div>
      </div>
      
      {/* Safe area for devices with notches */}
      <div className="bg-white/70 backdrop-blur-2xl h-[env(safe-area-inset-top)]" />
    </div>
  );
}
